import React, { useEffect, useRef, useState } from 'react';
import Lista, { ListaRef } from './Lista';
import { SelectType, ElementIcmsItemProps } from './types';
import { InputContainer, Content } from './styles';

export const ElementIcmsItem: React.FC<ElementIcmsItemProps> = ({
  trib,
  options,
  type,
  onChange,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const listaRef = useRef<ListaRef>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState<SelectType | null>(
    options.find((opt) => opt.value === trib) || null,
  );

  useEffect(() => {
    const newSelected = options.find((opt) => opt.value === trib) || null;
    setSelected(newSelected);

    if (inputRef.current) {
      inputRef.current.value = newSelected?.label || '';
    }
  }, [trib, options]);

  const handleSetSelected = (opt: SelectType | null) => {
    setSelected(opt);
    if (inputRef.current) {
      inputRef.current.value = opt?.label || '';
    }
    onChange(opt?.value);
  };

  // Fechar dropdown quando clicar fora
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);

  // fecha lista no scroll da tela/tabela, mas não da própria lista
  useEffect(() => {
    const handleScroll = (event: Event) => {
      const listaElement = listaRef.current?.element;
      if (listaElement && listaElement.contains(event.target as Node)) {
        return;
      }
      if (isOpen) setIsOpen(false);
    };

    const tableContainer = document.querySelector(
      '.MuiTableContainer-root',
    ) as HTMLElement;

    if (tableContainer) {
      tableContainer.addEventListener('scroll', handleScroll);
    }
    window.addEventListener('scroll', handleScroll, true);

    return () => {
      if (tableContainer) {
        tableContainer.removeEventListener('scroll', handleScroll);
      }
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, [isOpen]);

  return (
    <InputContainer>
      <Content>
        <div className="form-group" ref={containerRef}>
          <label className="select-container">
            <input
              ref={inputRef}
              value={selected?.label || ''}
              type="text"
              className="form-control"
              onClick={() => {
                setIsOpen((prev) => !prev);
              }}
              readOnly
            />
            <div className="drop-indicator">
              <span role="img" aria-label="open">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  role="presentation"
                >
                  <path
                    d="M8.292 10.293a1.009 1.009 0 000 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 000-1.419.987.987 0 00-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 00-1.406 0z"
                    fill="currentColor"
                    fillRule="evenodd"
                  />
                </svg>
              </span>
            </div>
          </label>

          {isOpen && (
            <Lista
              ref={listaRef}
              options={options}
              inputRef={inputRef}
              setSelected={handleSetSelected}
              setIsOpen={setIsOpen}
            />
          )}
        </div>
      </Content>
    </InputContainer>
  );
};
